import { render } from "./ProductFavourites.vue?vue&type=template&id=71828bb3&scoped=true"
import script from "./ProductFavourites.vue?vue&type=script&lang=js"
export * from "./ProductFavourites.vue?vue&type=script&lang=js"

import "./ProductFavourites.vue?vue&type=style&index=0&id=71828bb3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71828bb3"]])

export default __exports__